import { Directive, afterNextRender, input, output, signal } from '@angular/core';

@Directive()
export abstract class AnimationBase {
  public readonly animationDuration = input<number>(0.3);
  public readonly animationEasing = input<string>('ease-in-out');
  public readonly animationEnterDelay = input<number>(0);

  public readonly handleAnimationStart = output<void>();
  public readonly handleAnimationEnd = output<void>();

  protected readonly shouldAnimate = signal(false);

  public constructor() {
    afterNextRender(() => {
      setTimeout(() => this.shouldAnimate.set(true), 200);
    });
  }
}
